module.exports = __webpack_public_path__ + "static/oficina_virtual-min-b40ffa9ca7c082f3be02363bcf5a50b4.jpg";